import Button from 'common/components/buttons/button';
import { ButtonTheme } from 'common/components/buttons/button-theme';

interface QuerySegmentsButtonProps {
  enabled?: boolean;
  isLoading: boolean;
  onClick: () => void;
}

const QuerySegmentsButton = (props: QuerySegmentsButtonProps) => {
  const { enabled, isLoading, onClick } = props;

  return (
    <Button
      identifier="query-segments"
      theme={ButtonTheme.SECONDARY}
      isLoading={isLoading}
      isDisabled={!enabled}
      onClick={onClick}
    >
      <span>Query</span>
    </Button>
  );
};

export default QuerySegmentsButton;
